import { TIPS_MODULE } from '../../Helpers/ManageTips'
import { PERMISSIONS } from '../../Helpers/Permission'
import { ENTITLEMENT_CONTROL_POLICY_CRUD, LANGUAGE_CONTROL_POLICY_CRUD } from '../ApiDefinations'
import { BREADCRUMS } from '../Breadcrums'
import { CONSTANTS } from '../Constant'
import {
  ENTITLEMENT_CONTROL_POLICY_SCHEMA,
  ENTITLEMENT_CONTROL_POLICY_VIEW_SCHEMA,
  LANGUAGE_CONTROL_POLICY_SCHEMA,
  LANGUAGE_CONTROL_POLICY_VIEW_SCHEMA,
} from './schema'

const POPUP_MSG_CONSTANTS = {
  DEL_LINE_1: 'Are you sure you want to delete',
  DEL_LINE_2: 'As this Policy may be mapped to existing assets.',
  ACTIVATE:
    'Are you sure you want to activate the previously deactivated Entitlement Control Policy',
  DEACTIVATE: 'Are you sure you want to deactivate the Entitlement Control Policy',
}

export const MANAGE_POLICY_CONSTANTS: any = {
  DAY_OPTIONS: [
    { key: 'Sun', value: 'sun' },
    { key: 'Mon', value: 'mon' },
    { key: 'Tue', value: 'tue' },
    { key: 'Wed', value: 'wed' },
    { key: 'Thu', value: 'thu' },
    { key: 'Fri', value: 'fri' },
    { key: 'Sat', value: 'sat' },
  ],
  CONFIG: {
    'entitlement-control-policy': {
      subModule: 'entitlement',
      pageName: CONSTANTS.CONTROL_POLICY_VIEW_PAGE,
      popupTitle: CONSTANTS.ENTITLEMENT_CONTROL_POLICY,
      editURL: '/manage-policies/entitlement-control-policy/edit/',
      urlAfterDelete: '/manage-policies/entitlement-control-policy',
      viewSchema: ENTITLEMENT_CONTROL_POLICY_VIEW_SCHEMA,
      accessPermission: PERMISSIONS.MANAGE_POLICIES_ENTITLEMENT_CONTROL_POLICY,
      deletePopupLine1: POPUP_MSG_CONSTANTS.DEL_LINE_1,
      deletePopupLine2: POPUP_MSG_CONSTANTS.DEL_LINE_2,
      activatePopupLine:
        'Are you sure you want to activate the previously deactivated Entitlement Control Policy',
      deactivatePopupLine: 'Are you sure you want to deactivate the Entitlement Control Policy',
      detailsAPIPayload: ENTITLEMENT_CONTROL_POLICY_CRUD.GET_POLICY_DETAILS,
      deleteAPIPayload: ENTITLEMENT_CONTROL_POLICY_CRUD.DELETE_POLICY,
      statusAPIPayload: ENTITLEMENT_CONTROL_POLICY_CRUD.UPDATE_POLICY,
    },
    'language-control-policy': {
      subModule: 'language',
      pageName: CONSTANTS.CONTROL_POLICY_VIEW_PAGE,
      popupTitle: CONSTANTS.LANGUAGE_CONTROL_POLICY,
      editURL: '/manage-policies/language-control-policy/edit/',
      urlAfterDelete: '/manage-policies/language-control-policy',
      viewSchema: LANGUAGE_CONTROL_POLICY_VIEW_SCHEMA,
      accessPermission: PERMISSIONS.MANAGE_POLICIES_LANGUAGE_CONTROL_POLICY,
      deletePopupLine1: POPUP_MSG_CONSTANTS.DEL_LINE_1,
      deletePopupLine2: POPUP_MSG_CONSTANTS.DEL_LINE_2,
      activatePopupLine:
        'Are you sure you want to activate the previously deactivated Language Control Policy',
      deactivatePopupLine: 'Are you sure you want to deactivate the Language Control Policy',
      detailsAPIPayload: LANGUAGE_CONTROL_POLICY_CRUD.GET_POLICY_DETAILS,
      deleteAPIPayload: LANGUAGE_CONTROL_POLICY_CRUD.DELETE_POLICY,
      statusAPIPayload: LANGUAGE_CONTROL_POLICY_CRUD.UPDATE_POLICY,
    },
  },
}

export const controlPolicyConstant: any = {
  '/manage-policies/entitlement-control-policy': {
    initialFieldSchema: ENTITLEMENT_CONTROL_POLICY_SCHEMA,
    pageId: 1,
    apiUrl: {
      create: ENTITLEMENT_CONTROL_POLICY_CRUD.CREATE_POLICY,
      edit: ENTITLEMENT_CONTROL_POLICY_CRUD.UPDATE_POLICY,
      details: ENTITLEMENT_CONTROL_POLICY_CRUD.GET_POLICY_DETAILS,
    },
    redirectionPath: {
      create: '/manage-policies/entitlement-control-policy',
      edit: '/manage-policies/entitlement-control-policy/view/',
      back: '/manage-policies/entitlement-control-policy',
    },
    title: {
      create: 'Create Entitlement Control Policy',
      edit: 'Entitlement Control',
      name: 'policyName',
    },
    breadCrumbObj: BREADCRUMS.VIEW_ENTITLEMENT_CONTROL_POLICY,
    defaultListing: '/manage-policies/entitlement',
    toolTips: TIPS_MODULE.CONTROL_POLICY,
  },
  'manage-policies/language-control-policy': {
    initialFieldSchema: LANGUAGE_CONTROL_POLICY_SCHEMA,
    pageId: 2,
    apiUrl: {
      create: LANGUAGE_CONTROL_POLICY_CRUD.CREATE_POLICY,
      edit: LANGUAGE_CONTROL_POLICY_CRUD.UPDATE_POLICY,
      details: LANGUAGE_CONTROL_POLICY_CRUD.GET_POLICY_DETAILS,
    },
    redirectionPath: {
      create: '/manage-policies/language-control-policy',
      edit: '/manage-policies/language-control-policy/view/',
      back: '/manage-policies/language-control-policy',
    },
    title: {
      create: 'Create Language Control Policy',
      edit: 'Language Control',
      name: 'policyName',
    },
    breadCrumbObj: BREADCRUMS.VIEW_LANGUAGE_CONTROL_POLICY,
    defaultListing: '/manage-policies/language',
    toolTips: TIPS_MODULE.LANGUAGE_CONTROL_POLICY,
  },
}

export const controlPolicyConfig = (key: string) => {
  for (const path in controlPolicyConstant) {
    if (key.includes(path)) {
      return controlPolicyConstant[path]
    }
  }
  return {}
}
export const POLICY_PAGE_ROUTES = ['/manage-policies/entitlement', '/manage-policies/language']
export const BLUK_PAGE_ROUTES = ['interactive-bulk-update', 'bulk-state-change']
export const languageProperties = [
  {
    id: 'image',
    fieldName: 'image',
    label: 'Image',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 0,
    class: 'list_image',
    content: false,
  },
  {
    id: 'blitzId',
    fieldName: 'blitzId',
    label: 'Blitz Id',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 1,
    class: 'list_asset_id',
    content: true,
  },
  {
    id: 'contentId',
    fieldName: 'contentId',
    label: 'Content Id',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 2,
    class: 'list_asset_id',
    content: true,
  },
  {
    id: 'state',
    fieldName: 'state',
    label: 'Asset State',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 3,
    content: true,
  },
  {
    id: 'metaAttributes.assetTitle',
    label: 'Title',
    dataType: 'STRING',
    fieldType: 'TEXT',
    fieldName: 'assetTitle',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    position: 4,
  },
  {
    id: 'metaAttributes.episodeTitle',
    label: 'Asset Title',
    dataType: 'STRING',
    fieldType: 'TEXT',
    fieldName: 'episodeTitle',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    position: 5,
  },
  {
    id: 'metaAttributes.defaultLang',
    label: 'Default Language',
    dataType: 'STRING',
    fieldType: 'SELECT',
    fieldName: 'defaultLang',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    select: true,
    position: 6,
  },
  {
    id: 'metaAttributes.audioLanguages',
    label: 'Available Audio Languages',
    dataType: 'STRING',
    fieldType: 'SELECT',
    fieldName: 'audioLanguages',
    isMultiple: true,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    select: true,
    position: 7,
  },
  {
    id: 'assetType',
    fieldName: 'assetType',
    label: 'Asset Type',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 8,
    content: true,
  },
  {
    id: 'assetCategory',
    fieldName: 'assetCategory',
    label: 'Asset Category',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 9,
    content: true,
  },
  {
    id: 'contentCategory',
    fieldName: 'contentCategory',
    label: 'Content Category',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 10,
    content: true,
  },
  {
    id: 'metaAttributes.season',
    label: 'Season Number',
    dataType: 'NUMBER',
    fieldType: 'NUMBER',
    fieldName: 'season',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    position: 11,
  },
  {
    id: 'metaAttributes.episodeNumber',
    label: 'Episode Number',
    dataType: 'NUMBER',
    fieldType: 'NUMBER',
    fieldName: 'episodeNumber',
    isMultiple: false,
    sort: true,
    filter: false,
    assetCategory: '',
    assetType: '',
    metaCategory: '',
    class: '',
    content: false,
    viewInListing: true,
    position: 12,
  },
]
